<mat-card class="api-card" matRipple [matRippleRadius]="20" [matRippleColor]="'rgb(140,151,211,0.2)'">
    <mat-card-title>محاسبه‌گر عددی</mat-card-title>
    <mat-card-subtitle>برای عبارت عددی</mat-card-subtitle>
    <mat-card-content>
        <p>
            شما عبارتی را شامل <strong>«عددها» و «عمل‌گرها»</strong> به ورودی می‌دهید.
            <br>این API <b>عدد حاصل</b> را به عنوان خروجی به شما تحویل می‌دهد.
        </p>
        <p style="text-align: center;">
            <mat-card>
                <mat-card class="ioCard" [ngClass]="{'ioCard-on': inputValue}">
                    <p dir="rtl">ورودی</p>
                    <p class="input-p" dir="rtl">
                        <button (click)="clicked_to_get_example()" mat-raised-button color="basic">
                        مثال‌ساز خودکار
                      </button>


                        <mat-form-field class="example-form-field" dir="rtl">
                            <mat-label>خودتان یک مثال بنویسید</mat-label>
                            <input matInput type="text" dir="ltr" [(ngModel)]="inputValue">
                        </mat-form-field>
                        <button (click)="clicked_to_get_output()" [color]="'primary'" mat-raised-button color="basic">
                          ارسال
                        </button>
                    </p>
                    <p dir="rtl">خروجی</p>
                    <p dir="ltr" class="output-p">
                        {{ouputValue}}
                    </p>
                    <button mat-mini-fab (click)="clear_input_output()">
                        از نو
                      </button>
                </mat-card>
            </mat-card>
        </p>
    </mat-card-content>
    <!-- mat-card-image || mat-card-sm-image || mat-card-md-image ||
mat-card-lg-image || mat-card-avatar -->
    <!-- <img mat-card-lg-image src="https://material.angular.io/assets/img/examples/shiba1.jpg" alt="Shiba Inu"> -->
    <!-- align= "end" || "start" -->
    <mat-card-actions align="end">
        <button mat-raised-button color="basic">
          <mat-icon>more_vert</mat-icon> جزئیات
        </button>
        <button mat-raised-button color="primary">تزریق به پلت‌فرم</button>
        <button matTooltip="اگر صاحب وب‌سایت یا اپلیکیشن هستید می‌توانید این هوشمندی را به آن هم تزریق کنید." mat-icon-button color="primary" aria-label="Example icon button with a home icon">
          <mat-icon>info</mat-icon>
        </button>
    </mat-card-actions>
    <mat-card-footer>
        نسخه‌ی ۱.۰
    </mat-card-footer>
</mat-card>